var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"slider"},[_c('p',{staticClass:"slider__title"},[_vm._v("Grace period up to 51 days")]),_c('p',{staticClass:"slider__subtitle"},[_vm._v("free, without hidden fees and overpayments")]),_c('img',{attrs:{"src":require("@/assets/images/cat_fun.svg"),"alt":"imgCat"}})])])
}]

export { render, staticRenderFns }